var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneEnroute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 24 24",
    width: "100%",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.67524 2.73018L9.89399 9.63643L10.2065 10.6989L6.55024 10.7302L4.73774 10.7302L3.23774 8.73018L1.73774 8.69893L1.76899 8.76143L1.70649 8.76143L2.73774 12.1989L2.73774 12.2614L1.70649 15.6989L1.76899 15.6989L1.73774 15.7614L3.23774 15.7614L4.73774 13.7302L10.2377 13.7614L10.019 14.4177L7.67524 21.7302L9.67524 21.7614L13.3315 15.9489L14.7065 13.7614L20.2065 13.7927C21.0338 13.8042 21.7333 13.1271 21.7377 12.2927C21.7377 12.2678 21.7078 12.2548 21.7065 12.2302C21.7078 12.2056 21.7377 12.1925 21.7377 12.1677C21.7333 11.3333 21.0338 10.6562 20.2065 10.6677L14.7065 10.6989L13.9252 9.48018L13.3315 8.51143L9.67524 2.73018L7.67524 2.73018Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneEnroute);
export default __webpack_public_path__ + "static/media/airplane-enroute.72a91d3f.svg";
export { ForwardRef as ReactComponent };